<template>
  <div>
    <v-form ref="prodForm">
      <v-row>
        <v-col cols="12" md="5">
          <v-row>
            <v-col cols="12" class="px-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab> Datos Subreceta </v-tab>
                <v-tab :disabled="!usoRecetas.length"> Recetas </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab" class="py-10 px-2">
                <v-tab-item>
                  <v-row>
                    <v-col cols="12">
                      <h3>Datos de Subreceta</h3>

                      <v-row>
                        <v-col cols="12" class="py-0 mb-n6">
                          <v-autocomplete
                            disabled
                            v-model="productoData.Tipo"
                            :items="tiposProducto"
                            label="Tipo de producto"
                            @change="$forceUpdate()"
                            :rules="rules.Tipo"
                            item-value="id"
                            item-text="name"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12" class="mb-n6">
                          <v-text-field
                            v-model="productoData.Nombre"
                            :rules="rules.Nombre"
                            label="Nombre de subreceta"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="mb-n6">
                          <v-autocomplete
                            multiple
                            v-model="productoData.Departamentos"
                            :rules="rules.Departamento"
                            label="Departamento"
                            :items="modulos"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" class="mb-n6">
                          <v-autocomplete
                            v-model="productoData.Categoria"
                            label="Categoría de subreceta"
                            :items="categoriesList"
                            :rules="rules.Categoria"
                            item-value="id"
                            item-text="label"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12" class="mb-n6">
                          <v-text-field
                            v-if="!edit"
                            v-model="productoData.Codigo"
                            :rules="rules.Codigo"
                            label="Codigo de subreceta"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <h4>Uso en recetas</h4>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th>Receta</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(receta, index) in usoRecetas">
                        <tr :key="index">
                          <td>{{ receta.Nombre }}</td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="7" cols="12">
          <h3>Insumos de la subrecetas</h3>
          <v-btn
            @click="
              dialog = true;
              InsumoAdd.Cantidad = 1;
            "
            class="mx-2"
            outlined
            color="primary"
            ><v-icon>mdi-plus</v-icon> Agregar Insumos</v-btn
          >
          <v-btn @click="deleteInsumo()" outlined color="red"
            ><v-icon>mdi-delete</v-icon> Eliminar Insumos</v-btn
          >
          <h4>Insumos Agregados</h4>

          <v-divider></v-divider>
          <v-autocomplete
            class="mb-n7 btnDeptoSelector"
            outlined
            dense
            @input="getCostosByDoc()"
            v-model="selectedDeptoCosteo"
            label="Seleccione un departamento para calcular los costos"
            :items="selectedDeptos"
          >
          </v-autocomplete>
          <ag-grid-vue
            :key="tableKey"
            style="height: 300px"
            class="ag-theme-alpine"
            :columnDefs="columnDefs"
            rowSelection="single"
            :rowData="Catalogo"
            @gridReady="ongridReady($event)"
            @selection-changed="onSelectionChanged($event)"
          >
          </ag-grid-vue>
          <v-row>
            <v-col
              ><v-text-field
                v-model="Extra.AYB.Rm"
                :rules="rules.Requerido"
                label="Rendimiento"
            /></v-col>
            <v-col
              ><v-autocomplete
                v-model="Extra.AYB.UM"
                :items="tiposUm"
                :rules="rules.Requerido"
                label="Unidad de medida"
              ></v-autocomplete
            ></v-col>
            <v-col
              ><v-text-field
                v-model="Extra.AYB.Mm"
                :rules="rules.Porcentaje"
                label="Merma (%)"
              >
              </v-text-field
            ></v-col>
          </v-row>

          <v-btn
            :loading="startCosteo"
            class="mb-4"
            outlined
            color="primary"
            @click="costeo"
            block
          >
            <v-icon>mdi-calculator</v-icon>Previsualizar Costeo
          </v-btn>
          <v-simple-table
            v-if="costeoBySelectedDepto && costeos.costeado == false"
          >
            <tbody>
              <tr>
                <td><b>Costo Insumos:</b></td>
                <td>
                  <b>
                    <b>
                      {{
                        $pgsHelper.formatNumber(
                          costeoBySelectedDepto.C * Number(Extra.AYB.Rm)
                        )
                      }}</b
                    >
                  </b>
                </td>
              </tr>
              <tr>
                <td><b>Costo Rendimiento Unitario:</b></td>
                <td>
                  <b>
                    {{ $pgsHelper.formatNumber(costeoBySelectedDepto.C) }}
                  </b>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-alert v-if="costeos.costeado" dense text type="success">
            <table width="100%">
              <tbody>
                <tr>
                  <td width="50%"><b>Costo Insumos:</b></td>
                  <td width="50%">
                    <b>{{
                      costeos.utt
                        ? "$" + Number(costeos.utt.C).toFixed(2)
                        : "N/A"
                    }}</b>
                  </td>
                </tr>
                <tr>
                  <td width="50%"><b>Costo Rendimiento Unitario:</b></td>
                  <td width="50%">
                    <b>{{
                      costeos.uct
                        ? "$" + Number(costeos.uct.C).toFixed(2)
                        : "N/A"
                    }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-alert>
          <div class="text-right mt-6">
            <v-btn large @click="$emit('toggle', false)"> Cancelar </v-btn>
            <v-btn
              style="margin-left: 6px"
              color="success"
              large
              @click="checkForm"
              >Guardar</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Agregar Insumo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="iForm">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    :items="global_prod"
                    item-value="id"
                    item-text="Nombre"
                    v-model="InsumoAdd.Id"
                    @change="changeProd()"
                    :rules="rules.Requerido"
                    label="Insumo o Subreceta"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.Nombre }} -
                      {{
                        data.item.Extra.AYB.UM
                          ? " || Medida: " + data.item.Extra.AYB.UM
                          : ""
                      }}
                      - {{ " || Tipo: " + data.item.Tipo }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <span :class="insumoType(data.item.Tipo).color">
                          {{ data.item.Nombre }} -
                          {{
                            data.item.Extra.AYB.UM
                              ? " || Medida: " + data.item.Extra.AYB.UM
                              : ""
                          }}
                          - {{ " || Tipo: " + data.item.Tipo }}
                        </span>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    label="Cantidad"
                    :rules="rules.Requerido"
                    @keypress="
                      $pgsHelper.onlyNumber($event, InsumoAdd.Cantidad)
                    "
                    v-model="InsumoAdd.Cantidad"
                    type="number"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    label="Merma (%)"
                    :rules="rules.Porcentaje"
                    @keypress="$pgsHelper.onlyNumber($event, InsumoAdd.Mm)"
                    v-model="InsumoAdd.Mm"
                    type="number"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" text @click="addInsumo()">
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Producto from "../../../clases/Producto.js";
import Currency from "../../../clases/Currencies.js";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ProductosForm",
  components: { AgGridVue },
  props: ["edit", "dataEdit", "costos"],
  data() {
    return {
      tableKey: 0,
      tab: "dataSub",
      startCosteo: false,
      selectedDeptoCosteo: null,
      selection: [],
      dialog: false,
      productoData: new Producto(),
      initInv: false,
      Categories: [],
      errors: {},
      monedas: Currency.getCurrencies(),
      tiposProducto: Producto.getTiposProducto(),
      tiposUm: Producto.getTiposUm(),
      loader: true,
      rules: Producto.getRules(),
      columnDefs: null,
      rowData: null,
      Catalogo: [],
      costoActual: null,
      costeos: {
        costeado: false,
        cin: [],
        cmp: {},
        cmt: {},
        uct: { C: 0 },
        utt: {},
        Ganancia: null,
        porcentajeGanancia: null,
        utilidad: 0,
        precioSugerido: 0,
      },
      InsumoAdd: {
        Nombre: "",
        Id: "",
        Tipo: "",
        Cantidad: 1,
        //Precio: 0,
        Moneda: this.$Currencies.getCurrencyDefault(),
        Catalogo: [],
        Mm: 0,
        Extra: {},
      },
      Extra: {
        AYB: {
          UM: "",
          Rm: 0,
          Mm: 0,
        },
      },
    };
  },
  methods: {
    async costeo() {
      this.startCosteo = true;
      let dptos = Object.entries(this.productoData.Departamentos);
      if (!this.selectedDeptoCosteo && Number(this.Extra.AYB.Rm) <= 0) {
        this.$toast.error(
          "Verifica tener un departamento para costeo seleccionado y un rendimiento real",
          "Complete la informacion para costear"
        );
        this.startCosteo = false;
        return false;
      }

      if (dptos.length > 0) {
        let datos = {
          type: "INSUMOS",
          departamento: this.selectedDeptoCosteo,
          costoAdicional: 0,
          rendimiento: this.productoData.Extra.AYB.Rm,
          porciones: 1,
          insumos: [],
        };
        this.Catalogo.forEach((ins) => {
          datos.insumos.push({
            ins: ins.Id,
            cnt: Number(ins.Cantidad),
            mrm: Number(ins.Mm),
          });
        });
        await this.$store.getters.getFirebaseApp.fba
          .call("AYB-Costeo-costearReceta", datos)
          .then((result) => {
            this.startCosteo = false;
            this.costeos = result.data.data;
            console.log("costeo",this.costeos)
            if (this.costeos?.cin.length > 0) {
              this.costeos.cin.forEach((costoInsumo) => {
                let insumo = this.$pgsHelper.getById(
                  this.Catalogo,
                  "Id",
                  costoInsumo.ins
                );
                if (insumo) {
                  this.Catalogo[insumo.idx].costoData = costoInsumo;
                  this.Catalogo[insumo.idx].Costo = Number(
                    this.$pgsHelper.roundNumber(costoInsumo.uct.C)
                  );
                  this.Catalogo[insumo.idx].CostoMoneda = costoInsumo.uct.M;
                }
              });
            }
            this.costeos.costeado = true;
            this.costeos.Ganancia =
              Number(this.productoData.Precio) - Number(this.costeos.uct.C);
            if (
              this.productoData.Precio != "" &&
              Number(this.productoData.Precio) != 0
            ) {
              let porcentajeGanancia =
                (1 -
                  Number(this.costeos.uct.C) /
                    Number(this.productoData.Precio)) *
                100;
              this.costeos.porcentajeGanancia = porcentajeGanancia;
            } else {
              this.costeos.porcentajeGanancia = null;
            }
            this.$forceUpdate();
            this.tableKey++;
          })

          .catch((error) => {
            console.log(error);
            this.startCosteo = false;
          });
      }
    },
    changeProd() {
      let prod = this.$pgsHelper.getById(
        this.global_prod,
        "id",
        this.InsumoAdd.Id
      );
      this.InsumoAdd.Mm = prod?.Extra?.AYB?.Mm || 0;
    },
    deleteInsumo() {
      this.selection.forEach((selectProd) => {
        let prod = this.$pgsHelper.getById(this.Catalogo, "Id", selectProd.Id);
        if (prod) {
          this.Catalogo.splice(prod.idx, 1);
        }
      });
    },
    onSelectionChanged(params) {
      const selectedRows = params.api.getSelectedRows();

      this.selection = selectedRows;
    },
    ongridReady: function (params) {
      let gridApi = params.api;
      gridApi.sizeColumnsToFit();
      let gridColumnApi = params.columnApi;
    },
    checkForm: function (e) {
      if (this.$refs.prodForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          if (this.productoData.Tipo != "AYB-Producto") {
            this.productoData.Precio = 0;
            this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
          }
          doAction = "EDIT";
        } else {
          if (this.productoData.Tipo != "AYB-Producto") {
            this.productoData.Precio = 0;
            this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
          }
        }
        if (this.productoData.Precio == "") {
          this.productoData.Precio = 0;
          this.productoData.Moneda = this.$Currencies.getCurrencyDefault();
        }
        this.productoData.Extra = this.Extra;
        this.productoData.Extra.AYB.Rm = Number(this.productoData.Extra.AYB.Rm);
        this.productoData.Extra.AYB.Mm = Number(this.productoData.Extra.AYB.Mm);
        this.Catalogo.forEach((prod) => {
          prod.Cantidad = Number(prod.Cantidad);
          prod.Extra.AYB.Mm = Number(prod.Mm);
        });
        this.productoData.Catalogo = this.Catalogo;
        this.$emit("successData", this.productoData, doAction);
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    addInsumo() {
      if (this.$refs.iForm.validate()) {
        let prod = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          this.InsumoAdd.Id
        );
        if (prod) {
          this.InsumoAdd.Catalogo = prod.Catalogo || [];
          this.InsumoAdd.Tipo = prod.Tipo || "";
          this.InsumoAdd.Nombre = prod.Nombre || "";
          this.InsumoAdd.Extra = prod.Extra || null;
          this.InsumoAdd.UM = prod.Extra.AYB.UM;
        }

        this.Catalogo.push(this.$pgsHelper.cloneObj(this.InsumoAdd));
        this.dialog = false;
      }
    },
    getCostosByDoc() {
      this.Catalogo.forEach((insumo) => {
        let costoData = this.costos[insumo.Id];
        if (costoData) {
          let costoDeptoSelected = this.$pgsHelper.getById(
            costoData,
            "depto",
            this.selectedDeptoCosteo
          );
          if (costoDeptoSelected) {
            insumo.costoData = costoDeptoSelected;
            console.log(
              costoDeptoSelected,
              insumo.Cantidad,
              costoDeptoSelected.uct.C * insumo.Cantidad
            );
            insumo.Costo = Number(
              this.$pgsHelper.roundNumber(
                costoDeptoSelected.uct.C * insumo.Cantidad
              )
            );
            insumo.CostoMoneda = costoDeptoSelected.uct.M;
          }
        }
      });
    },
    insumoType(selectedType) {
      console.log("Tipo", selectedType);
      const types = [
        {
          type: "AYB-Insumo",
          color: "primary--text",
        },
        {
          type: "AYB-ICompuesto",
          color: "orange--text text-darken-1",
        },
      ];

      return types.filter((insumo) => insumo.type == selectedType)[0];
    },
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    costeoBySelectedDepto() {
      let costeo = null;
      let costo = this.$pgsHelper.getById(
        this.costoActual,
        "depto",
        this.selectedDeptoCosteo
      );
      if (costo) {
        costeo = costo.uct;
        console.log(this.costoActual, this.selectedDeptoCosteo);
      }
      return costeo;
    },
    selectedDeptos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      if (this.productoData.Departamentos.length > 0) {
        departamentos.forEach((element) => {
          if (this.productoData?.Departamentos.includes(element.id)) {
            dep.push({ value: element.id, text: element.Nombre });
          }
        });
      }

      return dep;
    },
    global_origen() {
      let ori = this.$store.getters.getCentrosConsumo;
      /*prod.forEach((element)=>{
            element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        })*/
      return ori;
    },
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    categoriesList() {
      let categories = [];
      if (this.productoData.Departamentos.length > 0) {
        this.Categories.forEach((categoria) => {
          this.productoData.Departamentos.forEach((modulo) => {
            if (modulo == categoria.Departamento) {
              categories.push(categoria);
            }
          });
        });
        return categories;
      } else {
        return this.Categories;
      }
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        if (
          (element.Tipo == "AYB-Insumo" || element.Tipo == "AYB-ICompuesto") &&
          !element.Dlat
        ) {
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      let data = productos;
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");
      return sortReservations;
    },
    usoRecetas() {
      let recetas = [];

      let prod = this.$store.getters.getProductos;
      prod.forEach((element) => {
        if (!element.Dlat) {
          if (element._CatIdx) {
            if (element._CatIdx.includes(this.productoData.Id)) {
              recetas.push(this.$pgsHelper.cloneObj(element));
            }
          }
        }
      });
      return recetas;
    },
  },
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.getCategories();
    this.loader = false;
    if (this.edit) {
      console.log(this.dataEdit);
      this.costoActual = this.dataEdit.Costeo;
      this.productoData = new Producto(this.dataEdit);
      this.Extra.AYB = this.productoData?.Extra?.AYB;
      this.Extra.AYB.Mm = this.productoData?.Extra?.AYB?.Mm;
      this.productoData.Catalogo.forEach((prod) => {
        let producto = this.$pgsHelper.getById(this.global_prod, "id", prod.Id);
        prod.Nombre = producto.Nombre;
        prod.UM = prod.Extra.AYB.UM;
        prod.Mm = prod.Extra.AYB.Mm;
      });
      this.Catalogo = this.productoData.Catalogo;
      this.selectedDeptoCosteo = this.productoData.Departamentos[0];
      this.getCostosByDoc();
    }
    this.productoData.Tipo = "AYB-ICompuesto";

    this.columnDefs = [
      { field: "Tipo", width: 300 },
      { field: "Nombre", width: 500 },
      {
        field: "Cantidad",
        editable: true,
        valueFormatter: (params) => params.data.Cantidad + " " + params.data.UM,
      },
      { field: "Mm", editable: true, headerName: "Merma %" },
      {
        field: "Costo",
        editable: false,
        cellClassRules: {
          CosteoError: "value===0",
        },
        valueFormatter: (params) =>
          params.data.Costo != null ? params.data.Costo : "-",
      },
    ];

    console.log("productoData", this.productoData);

    /* this.rowData = [
      { Tipo: "Insumo", model: "Celica", price: 35000 },
      { Tipo: "Ford", model: "Mondeo", price: 32000 },
      { Tipo: "Porsche", model: "Boxster", price: 72000 },
    ];*/
  },
};
</script>

<style>
.btnDeptoSelector {
  background: #a9a9a966 !important;
}
</style>
